export const saveData = (
  dsc,
  clr,
  selected,
  oar_low,
  oar_high,
  age_low,
  age_high,
  pref_age,
  income,
  education,
  pref_fans
) => {
  return {
    type: 'Save_Current_Saved_Search_Filters',
    data: {
      dsc: dsc,
      clr: clr,
      selected_filter: selected,
      oar_low: oar_low,
      oar_high: oar_high,
      age_low: age_low,
      age_high: age_high,
      pref_age: pref_age,
      income: income,
      education: education,
      pref_fans: pref_fans
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/scenes/PriorityColor/actions.js